import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { SharedDialogSurfaceProps } from './components/SharedDialogSurface';
import type { RefAttributes } from 'react';
import type { PremiumPromoDialogProps } from './components/PremiumNewOutlookPromoDialog';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NewOutlookPromoDialog" */ './lazyIndex'),
    { name: 'NewOutlookPromoDialog' }
);

export const SharedDialogSurface: LazyComponent<
    SharedDialogSurfaceProps & RefAttributes<HTMLDivElement>,
    HTMLDivElement,
    void
> = createLazyComponent(lazyModule, m => m.SharedDialogSurface);
export const PremiumNewOutlookPromoDialog: LazyComponent<PremiumPromoDialogProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PremiumNewOutlookPromoDialog, undefined, undefined, {
        onlyImportIf: () => isFeatureEnabled('acct-newOutlookPromoPremiumConsumers'),
    });

export const LazyOwaMonarchReferralCampaign: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.OwaMonarchReferralCampaign
);
